import "./detalhesMaterial.css";
import HeaderProtected from "../../componentes/headerProtected/header";
import Sidebar from "../../componentes/sideBar/SideBar";
import Heading from "../../componentes/fluxo-engenheiro/heading/heading";
import TableHistory from "../../componentes/fluxo-engenheiro/tableHistory/tableHistory";
import Log from "../../componentes/logOfQuestions/log";
import { useState, useEffect } from "react";
import ArrowNext from "../../assets/svgs/arrow-next.svg";

import {
  getSessionVerifyPn,
  classificationsAprroverTax,
  getClassificationsId,
  getClassificationsMessage,
  ClassificationsMessage,
  getClassificationsPn,
  editNaladi,
  classificationsAprroverEng,
  getSessionReset,
  classificationsTransfer,
} from "../../redux/actions/fluxoNSimilar";
import { AppDispatch, RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { getPnCode } from "../../redux/slices/sessionSlice";
import {
  useNavigate,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
import NoResultQuiz from "../../componentes/NoResultQuiz/NoResultQuiz";
import ModalAprover from "../../componentes/fluxo-tax/modalAprover/modalAprover";
import Notification from "../../componentes/fluxo-tax/Notification/notification";
import ModalGeneric from "../../componentes/fluxo-tax/modal/modal";
import functionDate from "../../utils/formatarData";
import Textnotifications from "../../utils/notifications";
import { useRoles } from "../../hooks/roles";
import SucessIcon from "../../assets/svgs/sucess.svg";
import { SkeletonWrapper } from "../../componentes/SkeletonWrapper/sleketonWrapper";
import { Pagination, PaginationItem } from "@mui/material";
import { CorrigirModal } from "../../componentes/corrigirModal/corrigirModal";
import { NaladiModal } from "../../componentes/NaladiComponent/naladiModal";
import { SupportFooter } from "../../componentes/supportFooter/supportFooter";
import { showNotificationUtil } from "../../utils/showNotificationUtil";
import { resolveNcmErrorMessage } from "../../utils/ncmErrorMessages";
import Modal from "../../componentes/modal/modal";
import History from "../../componentes/history/History";

const ArrowBackIcon = () => {
  return (
    <img
      src={ArrowNext}
      alt="Descrição da imagem"
      style={{ transform: "rotate(180deg)" }}
    />
  );
};

const ArrowNextIcon = () => {
  return <img src={ArrowNext} alt="Descrição da imagem" />;
};

const HOME_NOTIFICATION_KEY = "homeNotification";

const DetalhesMaterial = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [ncmApiError, setNcmApiError] = useState<string | null>(null);
  const { isTax, isEngineer } = useRoles();
  const [currentPage, setCurrentPage] = useState(1);
  const [, setApprover] = useState(false);
  const [corrigirText, setCorrigirText] = useState("");
  const [ncmCode, setNcmCode] = useState("");
  const [naladiCode, setNaladiCode] = useState("");
  const [commentText, setCommentText] = useState("");
  const [backgroudError, setBackgroudError] = useState("");
  const [notification, setNotification] = useState(false);
  const [labelNotification, SetLabelNotification] = useState("");
  const [isRead, setIsRead] = useState(false);
  const [modalApprover, setModalApprover] = useState(false);
  const [modalReset, setModalReset] = useState(false);
  const [modalTransfer, setModalTransfer] = useState(false);
  const [loading, setLoading] = useState(true);
  const [modalCorrigir, setModalCorrigir] = useState(false);
  const [modalNaladi, setModalNaladi] = useState(false);
  const location = useLocation();
  const { read } = location.state || {};
  const { id } = useParams<{ id: string }>();
  const [searchParams, setSearchParams] = useSearchParams();
  const centerUrl = searchParams.get("center");
  const activeTab = searchParams.get("tab") ?? "0";

  const handleTabChange = (tabId: string) => {
    const next = new URLSearchParams(searchParams);
    next.set("tab", tabId);
    setSearchParams(next, { replace: true });
  };

  const sessionMaterial = useSelector(
    (state: RootState) => state.sessionClassifications?.sessionMaterial,
  );
  const infosGrid = useSelector(
    (state: RootState) => state.sessionInfo?.sessionVerify.infosGrid,
  );
  const sessionMessageList = sessionMaterial?.sessionMessageList ?? [];
  const sessionMetadata = sessionMaterial?.sessionMetadata ?? null;
  const [modalComentar, setModalComentar] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const itemsPerPage = 2;
  const totalPages = Math.ceil(sessionMessageList?.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = sessionMessageList?.slice(
    startIndex,
    startIndex + itemsPerPage,
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const isDetalhesMaterial =
      location.pathname.startsWith("/detalhes-material");

    if (isDetalhesMaterial) {
      document.body.classList.add("detalhes-material-bg");
    } else {
      document.body.classList.remove("detalhes-material-bg");
    }

    // remove ao desmontar
    return () => {
      document.body.classList.remove("detalhes-material-bg");
    };
  }, [location.pathname]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleDisableButton = (isDisabled: boolean) => {
    setIsButtonDisabled(isDisabled);
  };

  const attributeData = (sessionMetadata?.outputFile?.attributeList || []).map(
    (item: any) => ({
      subTitle: item.presentationName,
      value:
        item.productAttributeValue != null
          ? String(item.productAttributeValue)
          : "-",
      attType: item.attType,
    }),
  );

  const attributesNCM = attributeData.filter(
    (item: { attType: string }) => item.attType === "NCM",
  );
  const attributesNVE = attributeData.filter(
    (item: { attType: string }) => item.attType === "NVE",
  );
  const attributesImp = attributeData.filter(
    (item: { attType: string }) => item.attType === "DESTIMP",
  );
  const attributesExp = attributeData.filter(
    (item: { attType: string }) => item.attType === "DESTEXP",
  );

  const { exIpi, exIpiDescription } = sessionMetadata?.outputFile ?? {};

  const parts = [exIpi, exIpiDescription].filter((v) => v?.trim());
  const exValue = parts.length ? parts.join(" - ") : "";

  const attributesIpi = exValue ? [{ subTitle: "", value: exValue }] : [];

  useEffect(() => {
    if (isTax) {
      setApprover(true);
    }
  }, [isTax]);

  useEffect(() => {
    if (
      sessionMaterial?.classificationStatus?.name === "EM_ANALISE" &&
      isEngineer
    ) {
      dispatch(
        ClassificationsMessage({
          id: sessionMaterial?.classificationMessages[0]?.id,
          body: { read: true },
        }),
      );
      if (read !== true) {
        setIsRead(true);
      }
    }
  }, [isEngineer, sessionMaterial?.classificationStatus?.name]);

  const handleClickVerifyDetails = async (
    sessionId: string,
    center: string,
  ) => {
    await dispatch(getSessionVerifyPn({ pn: sessionId, ct: center })).unwrap();
    dispatch(
      getPnCode({
        pnNumberCode: sessionMaterial?.productCode,
        description: infosGrid?.description,
      }),
    );
    navigate("/emissao-laudo");
  };

  const handleApprover = async () => {
    const classificationId = sessionMaterial?.classificationId;

    if (!classificationId) {
      console.error("Classification ID is missing.");
      return;
    }

    setIsSubmitting(true);

    try {
      await (isTax
        ? dispatch(classificationsAprroverTax(classificationId)).unwrap()
        : dispatch(classificationsAprroverEng(classificationId)).unwrap());

      await dispatch(getClassificationsId({ id: classificationId }));

      setModalApprover(false);
      setNotification(true);
      setBackgroudError("#B8EFC9");

      SetLabelNotification(
        functionDate.formatBodyText(
          Textnotifications.getAprovarSuccess(sessionMaterial?.productCode),
        ),
      );

      setTimeout(() => setNotification(false), 5000);
    } catch (error: any) {
      if (error?.httpStatus === 422 || error?.httpStatus === 500) {
        setModalApprover(false);
        setNotification(true);
        setBackgroudError("#FFD9D9");

        SetLabelNotification(
          isTax
            ? functionDate.formatBodyText(Textnotifications.getAprovarError())
            : "Para aprovar essa classificação é necessário o papel de aprovador de engenharia.",
        );

        setTimeout(() => setNotification(false), 5000);
        return;
      }

      console.error("Erro ao aprovar laudo:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleReset = async () => {
    const sessionId = sessionMaterial?.sessionId;

    if (!sessionId) {
      setModalReset(false);
      setBackgroudError("#FFD9D9");
      showNotificationUtil(
        functionDate.formatBodyText(Textnotifications.getResetError(sessionMaterial?.productCode, true)),
        SetLabelNotification,
        setNotification,
      );
      return;
    }

    setIsSubmitting(true);

    try {
      await dispatch(getSessionReset(sessionId)).unwrap();

      await dispatch(
        getClassificationsId({ id: sessionMaterial?.classificationId }),
      );

      const successMessage = Textnotifications.getResetSuccess(sessionMaterial?.productCode);

      localStorage.setItem(
        HOME_NOTIFICATION_KEY,
        JSON.stringify({
          message: functionDate.formatBodyText(successMessage),
          backgroundError: "#B8EFC9",
        }),
      );

      setModalReset(false);
      navigate(isTax ? "/home-tax" : "/home-engenheiro");
    } catch (error: any) {
      setModalReset(false);

      const errorMessage = Textnotifications.getResetError(sessionMaterial?.productCode);

      setBackgroudError("#FFD9D9");
      showNotificationUtil(
        functionDate.formatBodyText(errorMessage),
        SetLabelNotification,
        setNotification,
      );

      console.error("Erro ao resetar classificação:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleTransfer = async () => {
    const classificationId = sessionMaterial?.classificationId;

    if (!classificationId) {
      console.error("Classification ID is missing.");
      return;
    }

    setIsSubmitting(true);

    try {
      await dispatch(classificationsTransfer(classificationId)).unwrap();

      await dispatch(getClassificationsId({ id: classificationId }));

      setModalTransfer(false);
      setBackgroudError("#B8EFC9");
      showNotificationUtil(
        "Classificação transferida com sucesso.",
        SetLabelNotification,
        setNotification,
      );
    } catch (error: any) {
      setModalTransfer(false);
      setBackgroudError("#FFD9D9");
      showNotificationUtil(
        "Não foi possível transferir a classificação. Tente novamente.",
        SetLabelNotification,
        setNotification,
      );

      console.error("Erro ao transferir classificação:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleNaladi = async () => {
    setModalNaladi(true);

    try {
      const response = await dispatch(
        editNaladi({
          id: sessionMaterial?.classificationId,
          naladi: naladiCode,
        }),
      );

      if (editNaladi.fulfilled.match(response)) {
        await dispatch(
          getClassificationsId({ id: sessionMaterial?.classificationId }),
        );
        setModalNaladi(false);
        SetLabelNotification(Textnotifications.getNaladiSuccess());
        setBackgroudError("#B8EFC9");
        setNaladiCode("");
        setNotification(true);
        setTimeout(() => {
          setNotification(false);
        }, 5000);
      } else {
        setNotification(true);
        setBackgroudError("#FFD9D9");
        SetLabelNotification("Ocorreu um erro inesperado. Tente novamente.");
        setTimeout(() => {
          setNotification(false);
        }, 5000);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCorrigir = async () => {
    if (!sessionMaterial?.classificationId) {
      console.error("Classification ID is missing.");
      return;
    }
    setIsSubmitting(true);
    setNcmApiError(null);
    try {
      const response = await dispatch(
        getClassificationsMessage({
          classificationId: sessionMaterial?.classificationId,
          message: corrigirText,
          userRole: "TAX",
          origin: isTax ? "JUSTIFICATIVA" : "JUSTIFICATIVA_ENG",
          ncmCode: isTax ? ncmCode : "",
        }),
      );

      if (getClassificationsMessage.fulfilled.match(response)) {
        await dispatch(
          getClassificationsId({ id: sessionMaterial?.classificationId }),
        );
        setModalCorrigir(false);
        SetLabelNotification(
          Textnotifications.getCorrigirSuccess(sessionMaterial?.productCode),
        );
        setBackgroudError("#B8EFC9");
        setNcmCode("");
        setCorrigirText("");
        localStorage.setItem(
          "PartNumberNotification",
          sessionMaterial?.productCode,
        );
        setNotification(true);
        setTimeout(() => {
          setNotification(false);
        }, 5000);
      } else if (
        response?.payload &&
        (response.payload.httpStatus === 422 ||
          response.payload.httpStatus === 500)
      ) {
        if (isTax) {
          setNcmApiError(resolveNcmErrorMessage(response.payload.message));
          setNotification(false);
        } else {
          setNotification(true);
          setBackgroudError("#FFD9D9");
          SetLabelNotification(
            "Para corrigir essa classificação é necessário o papel de aprovador de engenharia.",
          );
          setModalCorrigir(false);
          setTimeout(() => {
            setNotification(false);
          }, 5000);
        }
      } else {
        setNotification(true);
        setBackgroudError("#FFD9D9");
        SetLabelNotification("Ocorreu um erro inesperado. Tente novamente.");
        setTimeout(() => {
          setNotification(false);
        }, 5000);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleComment = async () => {
    if (!sessionMaterial?.classificationId) {
      console.error("Classification ID is missing.");
      return;
    }
    setIsSubmitting(true);
    try {
      const response = await dispatch(
        getClassificationsMessage({
          classificationId: sessionMaterial?.classificationId,
          message: commentText,
          userRole: "TAX",
          origin: "COMENTARIO",
        }),
      );

      const isCommentRequestError =
        response?.meta?.requestStatus === "rejected" ||
        Number(response?.payload?.httpStatus) >= 400;

      if (isCommentRequestError) {
        const errorPayload = response.payload;
        setModalComentar(false);
        setNotification(true);
        setBackgroudError("#FFD9D9");
        SetLabelNotification(
          errorPayload?.httpStatus === 404 &&
            errorPayload.message === "User not found!"
            ? "Usuário não encontrado."
            : functionDate.formatBodyText(Textnotifications.getComentarError()),
        );

        setTimeout(() => {
          setNotification(false);
        }, 5000);

        return;
      }

      await dispatch(
        getClassificationsId({ id: sessionMaterial?.classificationId }),
      );

      setModalComentar(false);
      setNotification(true);
      SetLabelNotification(
        functionDate.formatBodyText(
          Textnotifications.getComentarSuccess(sessionMaterial?.productCode),
        ),
      );
      setBackgroudError("#B8EFC9");

      setTimeout(() => {
        setNotification(false);
      }, 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleVisualizarMaterialPn = async () => {
    await new Promise((resolve) => setTimeout(resolve, 1500));
    const resultPn = await dispatch(
      getClassificationsPn({
        pn: id,
        ct: localStorage.getItem("selectedCenterForm")
          ? localStorage.getItem("selectedCenterForm")
          : centerUrl,
      }),
    );

    if (centerUrl) {
      await dispatch(
        getClassificationsId({
          id: resultPn?.payload?.message,
        }),
      );
    }

    setLoading(false);
  };

  useEffect(() => {
    handleVisualizarMaterialPn();
  }, []);

  return (
    <>
      <SkeletonWrapper loading={loading} />

      {!loading && (
        <>
          <Sidebar />
          <HeaderProtected
            tabs={[
              { id: "0", label: "Detalhes" },
              { id: "1", label: "Histórico" },
            ]}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />

          {activeTab === "0" && (
            <>
              <div className="containerDetalhesMaterial">
                {notification && (
                  <Notification
                    label={labelNotification}
                    backgroundError={backgroudError}
                    setNotification={setNotification}
                    top={"150px"}
                    img={SucessIcon}
                  />
                )}
                <Heading
                  titlePage="Detalhes do Material"
                  blockText="sim"
                  buttonVoltar={isTax ? "" : "sim"}
                  buttonAppover={isTax ? "sim" : ""}
                  statusProps="sim"
                  materialData={{
                    sessionId: sessionMaterial?.sessionId,
                    productCode: sessionMaterial?.productCode,
                    productSimilarCode: sessionMaterial?.productSimilarCode,
                    center: sessionMaterial?.center,
                    classificationStatus:
                      sessionMaterial?.classificationStatus?.name,
                    classificationID: sessionMaterial?.classificationId,
                    ncmCode: sessionMaterial?.sessionMetadata?.outputFile?.ncmCode,
                    emitter: sessionMaterial?.emitter,
                  }}
                  onTarget={handleClickVerifyDetails}
                  productCode={sessionMaterial?.productCode}
                  openModalAprover={() => setModalApprover(true)}
                  openModalComentar={() => setModalComentar(true)}
                  openModalCorrigir={() => setModalCorrigir(true)}
                  openModalNaladi={() => setModalNaladi(true)}
                  openModalResetar={() => setModalReset(true)}
                  openModalTransferir={() => setModalTransfer(true)}
                  isTax={isTax}
                  isRead={isRead}
                />
              </div>

              <div className="containerMaterial">
                <div className="column-1">
                  <TableHistory
                    titles="Atributos"
                    attType="NCM"
                    attributes={attributesNCM}
                    className="atributtes"
                    status={sessionMaterial?.classificationStatus?.name}
                  />
                  <TableHistory
                    titles="NVE"
                    attType="NVE"
                    attributes={attributesNVE}
                    className="nve"
                    status={sessionMaterial?.classificationStatus?.name}
                  />
                  <TableHistory
                    titles="EX IPI"
                    attType="IPI"
                    attributes={attributesIpi}
                    className="ipi"
                    status={sessionMaterial?.classificationStatus?.name}
                  />
                  <TableHistory
                    titles="Destaque de Importação"
                    attType="DESTIMP"
                    attributes={attributesImp}
                    className="destaque_imp"
                    status={sessionMaterial?.classificationStatus?.name}
                  />
                </div>

                <div className="column-2">
                  <h2 className="h2-material">Quiz de Classificação</h2>
                  {sessionMessageList && sessionMessageList.length > 0 ? (
                    <>
                      {paginatedData.map((item: any, index: any) => (
                        <Log
                          key={item.question}
                          pergunta={startIndex + index + 1}
                          label={item?.question}
                          message={item.answer}
                          textPlus="Ver mais"
                          modalTitleLog={`Pergunta ${startIndex + index + 1}`}
                          modalSubtitleLog={item.question}
                          modalTextLog={item.answer}
                        />
                      ))}
                      <Pagination
                        count={totalPages}
                        siblingCount={2}
                        onChange={handleChangePage}
                        color="primary"
                        page={currentPage}
                        renderItem={(item) => (
                          <PaginationItem
                            slots={{ previous: ArrowBackIcon, next: ArrowNextIcon }}
                            {...item}
                          />
                        )}
                        sx={{
                          marginTop: "10px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      />
                    </>
                  ) : (
                    <NoResultQuiz />
                  )}

                  <TableHistory
                    titles="Destaque de Exportação"
                    attType="DESTEXP"
                    attributes={attributesExp}
                    className="destaque_exp"
                    status={sessionMaterial?.classificationStatus?.name}
                  />
                </div>
              </div>
            </>
          )}

          {activeTab === "1" && (
            <div className="containerDetalhesMaterial">
              <History />
            </div>
          )}

          {modalApprover && (
            <ModalAprover
              titleModal="Aviso"
              titleDescription={
                isTax ? (
                  <div
                    className="titleAprover"
                    dangerouslySetInnerHTML={{
                      __html: functionDate.formatBodyText(
                        Textnotifications.getAprovarBodyText(),
                      ),
                    }}
                  />
                ) : (
                  <div
                    style={{ marginBottom: 20, marginTop: 15 }}
                    className="titleAprover"
                    dangerouslySetInnerHTML={{
                      __html: functionDate.formatBodyText(
                        Textnotifications.getCorrigirBodyText(),
                      ),
                    }}
                  />
                )
              }
              bodyModal={
                isTax ? (
                  <div
                    className="titleAproverText"
                    dangerouslySetInnerHTML={{
                      __html: functionDate.formatBodyText(
                        Textnotifications.getAprovarBodyDescription(
                          sessionMaterial?.productCode,
                          sessionMaterial?.sessionMetadata?.outputFile?.ncmCode,
                        ),
                      ),
                    }}
                  />
                ) : (
                  ""
                )
              }
              buttonOne="Aprovar"
              onConfirm={handleApprover}
              buttonTwo="Cancelar"
              onClose={() => setModalApprover(false)}
              isSubmitting={isTax ? isSubmitting : false}
            />
          )}

          {modalComentar && (
            <ModalGeneric
              titleModal="Aviso"
              titleLabel="Atenção: só é possível enviar um comentário, sem chance de edição posteriormente. Confira antes de confirmar."
              inputMotivo={true}
              titleDescription={
                <div
                  className="space titleAprover"
                  dangerouslySetInnerHTML={{
                    __html: functionDate.formatBodyText(
                      Textnotifications.getComentarPrompt(),
                    ),
                  }}
                />
              }
              bodyModal={""}
              buttonOne="Comentar"
              onConfirm={handleComment}
              commentText={commentText}
              buttonTwo="Cancelar"
              onClose={() => {
                setModalComentar(false);
                setCommentText("");
                setIsButtonDisabled(true);
              }}
              setCommentText={setCommentText}
              isButtonDisabled={isButtonDisabled}
              onDisableButton={handleDisableButton}
              isSubmitting={isSubmitting}
            />
          )}

          {modalCorrigir && (
            <CorrigirModal
              open={modalCorrigir}
              onClose={() => {
                setModalCorrigir(false);
                setCorrigirText("");

                if (isTax) {
                  setNcmCode("");
                  setIsButtonDisabled(true);
                  setNcmApiError(null);
                }
              }}
              onConfirm={handleCorrigir}
              corrigirText={corrigirText}
              setCorrigirText={setCorrigirText}
              isButtonDisabled={isButtonDisabled}
              onDisableButton={handleDisableButton}
              {...(isTax && {
                ncmCode,
                setNcmCode,
                isSubmitting,
                ncmApiError,
                setNcmApiError,
                mode: "material",
              })}
            />
          )}

          {modalNaladi && (
            <NaladiModal
              open={modalNaladi}
              onClose={() => {
                setModalNaladi(false);
                setCorrigirText("");
                setNcmCode("");
                setIsButtonDisabled(true);
                setNcmApiError(null);
              }}
              onConfirm={handleNaladi}
              naladiCode={naladiCode}
              setNaladiCode={setNaladiCode}
              isButtonDisabled={isButtonDisabled}
              onDisableButton={handleDisableButton}
              isSubmitting={isSubmitting}
              ncmApiError={ncmApiError}
              setNcmApiError={setNcmApiError}
              mode="material"
            />
          )}

          {modalReset && (
            <Modal
              titleDescription="Você deseja resetar a classificação?"
              titleModal="Aviso"
              bodyModal={
                <span className="resetModalBody">
                  Ao confirmar a ação, a classificação voltará para o status
                  "Novo" e o processo será reiniciado do zero.
                </span>
              }
              onClose={() => setModalReset(false)}
              onConfirm={handleReset}
              buttonOne="Resetar"
              buttonTwo="Cancelar"
              className="modalLogouts"
              isSubmitting={isSubmitting}
            />
          )}

          {modalTransfer && (
            <Modal
              titleDescription="Você deseja assumir a classificação?"
              titleModal="Aviso"
              bodyModal={
                <span className="resetModalBody">
                  Ao confirmar você se tornará responsável pelo preenchimento das
                  informações deste item, e o usuário antigo deixará de ser o
                  emitente do item.
                </span>
              }
              onClose={() => setModalTransfer(false)}
              onConfirm={handleTransfer}
              buttonOne="Confirmar"
              buttonTwo="Cancelar"
              className="modalLogouts"
              isSubmitting={isSubmitting}
            />
          )}
        </>
      )}
      <SupportFooter />
    </>
  );
};

export default DetalhesMaterial;
